module.exports = __webpack_public_path__ + "img/full5-min.eafc14e9.png";